/* HobbyChef — konfigurátor gravírování.

   Sdílí ho produktovka (sections/hc-product-main.liquid) a košíkový panel
   (sections/hc-cart-drawer.liquid), markup je ve snippets/hc-engrave.liquid.
   Do 10. 9. 2026 to byl inline skript produktovky, který se navěšoval na
   konkrétní prvky při načtení. Panel se ale po každé změně košíku
   překresluje ze serveru, proto je tu všechno delegované na document.

   Co dělá: rozbalí konfigurátor po zaškrtnutí, počítá znaky, přepisuje
   ukázky písma a náhled na čepeli a nepustí prázdné zadání — s vlastní
   českou hláškou pod polem místo bubliny prohlížeče. Do košíku nic
   neposílá: na produktovce to dělá formulář (a hobbychef-cart.js
   addFromForm), v panelu hobbychef-cart.js po tlačítku Uložit.

   Bez JS zůstane panel tak, jak ho vykreslil server. */
(function () {
  'use strict';

  var VYCHOZI_CHYBA = 'Napište text, který chcete vygravírovat.';

  /* Psaný řez se stahuje až při prvním otevření — kvůli náhledu nemá
     smysl zdržovat načtení celé stránky. */
  var pismoNacteno = false;
  function pismo() {
    if (pismoNacteno) return;
    pismoNacteno = true;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@1,500&display=swap';
    document.head.appendChild(l);
  }

  function panelOf(toggle) {
    return document.getElementById(toggle.getAttribute('aria-controls') || '');
  }

  /* Prázdné pole — i jen s mezerami — je chyba, dokud je gravírování
     zapnuté. `required` samo mezery pustí a jeho bublina mluví jazykem
     prohlížeče, proto vlastní hláška přes setCustomValidity. */
  /* Návrhář s logem (hobbychef-engrave-designer.js): když zákazník nahrál
     logo, text už povinný není. Jinde se nic nemění. */
  function maLogo(input) {
    var p = input.closest ? input.closest('[data-hc-engrave]') : null;
    var f = p && p.querySelector('[data-hcd-logo-file]');
    return !!(f && !f.disabled && f.files && f.files.length);
  }

  function validity(input) {
    var logo = maLogo(input);
    if (!input.disabled) input.required = !logo;
    var chyba = !input.disabled && !input.value.trim() && !logo;
    input.setCustomValidity(chyba ? (input.getAttribute('data-hc-engrave-msg') || VYCHOZI_CHYBA) : '');
    return !chyba;
  }

  function showError(panel, on) {
    if (!panel) return;
    var el = panel.querySelector('[data-hc-engrave-error]');
    var input = panel.querySelector('[data-hc-engrave-input]');
    if (el) el.hidden = !on;
    if (input) {
      input.classList.toggle('is-invalid', !!on);
      if (on) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  /* Počítadlo, ukázky v dlaždicích, náhled a zvolené písmo náhledu. */
  function refresh(panel) {
    if (!panel) return;
    var input = panel.querySelector('[data-hc-engrave-input]');
    var count = panel.querySelector('[data-hc-engrave-count]');
    var preview = panel.querySelector('[data-hc-engrave-preview]');
    var box = panel.querySelector('[data-hc-engrave-preview-box]');
    var vybrane = panel.querySelector('[data-hc-engrave-font]:checked');
    var vzor = panel.getAttribute('data-hc-engrave-vzor') || '';
    var v = input ? input.value.trim() : '';

    if (input && count) count.textContent = String(input.value.length);
    panel.querySelectorAll('[data-hc-engrave-sample]').forEach(function (s) { s.textContent = v || vzor; });
    if (preview) preview.textContent = v || vzor;
    if (box && vybrane) box.setAttribute('data-font', vybrane.getAttribute('data-hc-engrave-font'));
    /* Hláška zmizí, jakmile je v poli text; ukáže se až při odeslání. */
    if (input && validity(input)) showError(panel, false);
  }

  /* Rozbalit / sbalit podle zaškrtávátka. Vypnutá pole se do formuláře
     neposílají — jinak by se k noži přidala prázdná vlastnost „text“
     i u objednávky bez gravírování. Uložené gravírování v košíku je
     zaškrtnuté, ale sbalené do shrnutí (atribut data-hc-engrave-sbaleno). */
  function sync(toggle, fokus) {
    var panel = panelOf(toggle);
    if (!panel) return;
    var on = toggle.checked;
    var open = on && !panel.hasAttribute('data-hc-engrave-sbaleno');
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    panel.querySelectorAll('input').forEach(function (f) { f.disabled = !on; });
    var input = panel.querySelector('[data-hc-engrave-input]');
    if (input) {
      input.required = on;
      if (open && fokus) input.focus({ preventScroll: true });
    }
    if (!on) showError(panel, false);
    if (on) pismo();
    refresh(panel);
  }

  function init(root) {
    var r = root || document;
    r.querySelectorAll('[data-hc-engrave-toggle]').forEach(function (t) { sync(t, false); });
    /* Miniatura s psaným řezem v košíku (snippets/hc-engrave-thumb.liquid)
       potřebuje totéž písmo jako konfigurátor. */
    if (r.querySelector('[data-hc-engrave-thumb][data-font="3"]')) pismo();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-hc-engrave-toggle]')) sync(t, true);
    else if (t.matches('[data-hc-engrave-font]')) refresh(t.closest('[data-hc-engrave]'));
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-hc-engrave-input]')) refresh(t.closest('[data-hc-engrave]'));
  });

  /* Neplatné odeslání (formulář produktovky i reportValidity v panelu):
     bublinu prohlížeče potlačit a ukázat vlastní hlášku. `invalid`
     nebublá, proto zachycení. */
  document.addEventListener('invalid', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-hc-engrave-input]')) return;
    e.preventDefault();
    showError(t.closest('[data-hc-engrave]'), true);
    if (document.activeElement !== t) t.focus();
  }, true);

  /* Pro košíkový panel: po překreslení znovu srovnat stav a vrátit
     rozepsaný koncept (hobbychef-cart.js). */
  window.hcEngrave = { init: init, sync: sync, refresh: refresh };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
}());
